import { extractApiErrorMessage } from './extract-api-error-message'
import { proxifyVolcArkTosFetchUrl } from './official/volc-ark-tos-fetch-url'
import {
  extractStatus,
  extractMedia,
  extractImageUrls,
  pickFirstNonEmpty,
  shouldKeepPollingEmptyImagesPayload,
  parseMidjourneyImagePoll,
  toDataMediaUrl
} from './aim-unified-poll-common'

/**
 * 自建图片模型的查询状态在 generations[0].status 中，优先读它避免误判外层 SUCCESS。
 */
function getSdGenerationStatus(stateData) {
  var nodes = []
  if (stateData && typeof stateData === 'object') {
    nodes.push(stateData)
    if (stateData.data && typeof stateData.data === 'object') {
      nodes.push(stateData.data)
      if (stateData.data.data && typeof stateData.data.data === 'object') nodes.push(stateData.data.data)
    }
  }
  for (var i = 0; i < nodes.length; i++) {
    var node = nodes[i]
    if (Array.isArray(node.generations) && node.generations.length > 0) {
      return pickFirstNonEmpty(node.generations[0], ['status', 'task_status', 'state', 'code'])
    }
  }
  return ''
}

/**
 * /aim/call 统一轮询 — image：model_type=image
 */
export function runWanUnifiedPollImageBranch(args) {
  var stateData = args.stateData
  var stateRes = args.stateRes
  var modelName = args.modelName
  var modelType = args.modelType
  var finishWithParsed = args.finishWithParsed
  var scheduleNext = args.scheduleNext
  var callback = args.callback

  if (modelName === 'midjourney') {
    var mjPoll = parseMidjourneyImagePoll(stateData)
    if (mjPoll) {
      if (mjPoll.kind === 'wait') {
        if (typeof callback === 'function') callback(null, { status: 'processing' })
        scheduleNext()
        return
      }
      if (mjPoll.kind === 'failed') {
        finishWithParsed({ status: 'failed', error: mjPoll.error || '生成失败' })
        return
      }
      if (mjPoll.kind === 'done' && mjPoll.url) {
        var puMj = proxifyVolcArkTosFetchUrl(String(mjPoll.url))
        finishWithParsed({ status: 'completed', url: puMj, urls: [puMj] })
        return
      }
    }
  }
  if (modelName === 'sd' || modelName === 'flux') {
    var ownImageStatus = String(getSdGenerationStatus(stateData) || '').trim().toLowerCase()
    if (ownImageStatus === 'processing' || ownImageStatus === 'pending' || ownImageStatus === 'queued' || ownImageStatus === 'running' || ownImageStatus === 'in_progress') {
      if (typeof callback === 'function') callback(null, { status: 'processing' })
      scheduleNext()
      return
    }
  }
  var statusImg = extractStatus(stateData)
  if (statusImg === 'failed') {
    var errMsgImg = extractApiErrorMessage(stateData) || '生成失败'
    finishWithParsed({ status: 'failed', error: errMsgImg })
    return
  }
  if (statusImg !== 'completed') {
    if (typeof callback === 'function') callback(null, { status: 'processing' })
    scheduleNext()
    return
  }
  if (shouldKeepPollingEmptyImagesPayload(stateData)) {
    if (typeof callback === 'function') callback(null, { status: 'processing' })
    scheduleNext()
    return
  }
  var imgUrls = extractImageUrls(stateData)
  if (!imgUrls.length && stateRes && stateRes.data) imgUrls = extractImageUrls(stateRes.data)
  if (imgUrls.length) {
    var proxiedImg = imgUrls.map(function (u) {
      return proxifyVolcArkTosFetchUrl(String(u))
    })
    finishWithParsed({
      status: 'completed',
      url: proxiedImg[0],
      urls: proxiedImg
    })
    return
  }
  var mediaImg = extractMedia(stateData)
  if (mediaImg.url) {
    var pu = proxifyVolcArkTosFetchUrl(String(mediaImg.url))
    finishWithParsed({ status: 'completed', url: pu, urls: [pu] })
    return
  }
  if (mediaImg.base64) {
    var dataUrlImg = toDataMediaUrl(mediaImg.base64, modelType)
    finishWithParsed({ status: 'completed', url: dataUrlImg, urls: [dataUrlImg] })
    return
  }
  var errImg = extractApiErrorMessage(stateData) || '未返回图片结果'
  finishWithParsed({ status: 'failed', error: errImg })
}
